import { Card, CardColors, Progress, Separator, Text } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'
import { useReselector } from '@/utils/sharedHooks'
import { formatCurrency } from '@/utils/currencyHelpers'
import { selectCubkProgressForDisplay } from './cubk.selectors'

const formatDollarDisplay = (value: number | null): string => {
  if (value === null) return '$-'
  return formatCurrency(value)
}

export const CubkProgressPanel = () => {
  const progress = useReselector(selectCubkProgressForDisplay)

  return (
    <Card color={CardColors.LEVEL_0_NO_BORDER} className="mt-0">
      <div className="flex flex-col gap-6">
        <Text variant={TypographyStyles.LABEL_MD}>Bookkeeping progress</Text>

        <div>
          <div className="flex items-center gap-3">
            <Progress value={progress.percentage} className="flex-1" />
            <Text
              variant={TypographyStyles.BODY_SM}
              className="text-moss-300 font-semibold shrink-0"
            >
              {progress.percentage}%
            </Text>
          </div>
          <Text
            variant={TypographyStyles.LABEL_SM}
            color={TextColors.MUTED}
            className="mt-1"
          >
            {progress.totalTransactions > 0
              ? `of ${progress.totalTransactions.toLocaleString()} transactions categorized`
              : 'transactions categorized'}
          </Text>
        </div>

        <Separator />

        <div className="grid grid-cols-2 gap-x-4 gap-y-6">
          <div className="flex flex-col gap-0.5">
            <Text variant={TypographyStyles.DISPLAY_XXS}>
              {formatDollarDisplay(progress.incomeCategorized)}
            </Text>
            <Text variant={TypographyStyles.LABEL_SM} color={TextColors.MUTED}>
              Income categorized
            </Text>
          </div>
          <div className="flex flex-col gap-0.5">
            <Text variant={TypographyStyles.DISPLAY_XXS}>
              {formatDollarDisplay(progress.expensesCategorized)}
            </Text>
            <Text variant={TypographyStyles.LABEL_SM} color={TextColors.MUTED}>
              Expenses categorized
            </Text>
          </div>
          <div className="flex flex-col gap-0.5">
            <Text variant={TypographyStyles.DISPLAY_XXS}>
              {formatDollarDisplay(progress.taxDeductionsFound)}
            </Text>
            <Text variant={TypographyStyles.LABEL_SM} color={TextColors.MUTED}>
              Tax deductions found
            </Text>
          </div>
        </div>
      </div>
    </Card>
  )
}
